export const normalizeVersion = (version) => {
  const v = (version || 'FREE').toUpperCase();
  return v === 'NORMAL' ? 'FREE' : v;
};

export const VERSION_LEVELS = {
  DEMO: 1,
  FREE: 2,
  PRO: 3,
  PREMIUM: 3
};

export const ACCESS_MAP = {
  "/consultations": "DEMO",
  "/financial": "FREE",
  "/reports": "PRO",
  "/settings": "FREE",
  "/home": "DEMO",
  "/admin/reports": "PRO",
  "/admin/test-users": "PRO"
};

export const FEATURES_ACCESS = {
  // Consultas
  "video.basic": "DEMO",
  "video.fullscreen": "FREE",
  "video.recording": "FREE",
  "video.transcription": "PRO",
  "video.summaryAI": "PRO",

  // Financeiro
  "banks.drawer": "FREE",
  "banks.accounts": "FREE",
  "banks.integrations": "PRO",

  // Relatórios
  "reports.basic": "FREE",
  "reports.analytics": "PRO",

  // Sala de Espera
  "waitingroom.customMedia": "FREE",
  "waitingroom.AIinteraction": "PRO",

  // Configurações
  "settings.theme": "DEMO",
  "settings.notifications": "FREE",
  "settings.integrations": "PRO"
};

